import { Box, styled } from '@mui/material';

const AddressText = styled(Box)`
  cursor: text;
  width: 100%;
  min-width: 100px;
  font-size: 0.875rem;
  line-height: 1.43;
  min-height: 29px;
  padding-top: 4.25px;
  padding-bottom: 4.25px;
`;

export default AddressText;
